import { createContext, useState, useEffect, useCallback } from "react";
import api from "../utils/axiosInstance";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Re-reads /auth/me so chrome that renders the name or avatar picks up an
  // edit made on the profile screen without a page reload.
  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user || data);
    } catch {
      // A failed refresh leaves the existing session state alone; the axios
      // interceptor already handles an expired one.
    }
  }, []);

  // Log when setUser is called
  const setUserWithLogging = (userData) => {
    console.log("🔵 AuthContext: setUser called with:", userData);
    setUser(userData);
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data } = await api.get("/auth/me");
        console.log("✅ AuthContext: Initial auth check successful:", data);
        setUser(data.user || data);
      } catch (err) {
        console.warn("⚠️ AuthContext: Auth check failed:", err?.response?.status);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, setUser: setUserWithLogging, loading, refreshUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};
